<div class="px-6 pt-5 pb-4 border-b border-gray-100">
  <h3 class="text-lg font-semibold">Choisissez vos produits</h3>

  <div class="mt-2 inline-flex items-center gap-1.5 bg-green-50 border border-green-200
              text-green-700 text-sm font-semibold px-3 py-1.5 rounded-full">
    @if (data.rule.reduction?.type === 'PERCENTAGE') {
      <span>
        🎁 Remise de {{ (data.rule.reduction?.value || 0) * 100 | number:'1.0-0' }}% par produit
      </span>
    }
    @if (data.rule.reduction?.type === 'FIXED_AMOUNT') {
      <span>
        🎁 Remise de {{ data.rule.reduction?.value || 0 | number:'1.2-2' }}€ par produit
      </span>
    }
    @if (data.rule.reduction?.type === 'SET_PRICE') {
      <span>
        Chaque produit de la promo est à {{ data.rule.reduction?.value || 0 | number:'1.2-2' }}€
      </span>
    }
  </div>
</div>
<mat-dialog-content class="p-4 overflow-y-auto">
  <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">

    @for (product of products; track product.id) {
    <div
         class="relative bg-base-200 rounded-2xl overflow-hidden
                transition-all duration-200"
        [class.border-secondary]="sel(product.id).quantity > 0"
        [class.shadow-md]="sel(product.id).quantity > 0"
        [class.opacity-60]="product.available === false"
        [class.cursor-not-allowed]="product.available === false"
        [class.cursor-pointer]="product.available === true">
        @if (product.available === false) {
          <span
            class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
            Non disponible
          </span>
        }
    <div class="relative w-full h-36 overflow-hidden rounded-[12px] bg-white">
           <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
           [alt]="product.name || 'Image à venir'"
           fill
           loading="lazy"
           sizes="(max-width: 640px) 50vw, 33vw"
           class="object-contain rounded-[12px]" />
                @if (sel(product.id).quantity > 0) {
              <div
             class="absolute top-2 right-2 bg-orange-500 text-white text-xs
                    font-bold w-6 h-6 rounded-full flex items-center justify-center shadow">
                {{ sel(product.id).quantity }}
              </div>
            }
          </div>
          <div class="p-3">
            <p class="font-medium text-sm leading-tight line-clamp-2 min-h-[40px]">
              {{ product.name }}
            </p>
            @if (productHasSizes(product)) {
              <div class="mt-2">
                <mat-form-field appearance="outline" class="w-full text-xs">
                  <mat-select
                    [value]="sel(product.id).selectedSizeId || ''"
                    (selectionChange)="onSizeChange(product, $event.value)"
                    placeholder="Choisir une taille...">
                    <mat-option value="">
                      Choisir taille
                    </mat-option>
                    @for (size of getProductSizes(product); track size) {
                      <mat-option [value]="size.id">
                        {{ size.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <p class="text-primary font-bold text-base mt-1.5 flex flex-col">
              @if (getDisplayPrice(product) > 0) {
                <!-- Prix original barré -->
                <span class="line-through text-gray-400 text-sm font-normal mr-1">
                  {{ getDisplayPrice(product) | number:'1.2-2' }} €
                </span>
                <!-- Prix après remise -->
                <span class="text-primary font-bold">
                  {{ getDiscountedUnitPrice(product) | number:'1.2-2' }} €
                </span>
              } @else {
                <span class="text-gray-400 text-[12px] font-normal">
                  {{ productHasSizes(product) ? 'Choisissez une taille pour ajouter' : '—' }}
                </span>
              }
            </p>
            <div class="mt-2 flex items-center gap-2">
              <button
                (click)="decrement(product)"
                [disabled]="sel(product.id).quantity === 0"
            class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center
            hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                −
              </button>
              <span class="flex-1 text-center font-semibold text-sm">
                {{ sel(product.id).quantity }}
              </span>
              <button
                (click)="increment(product)"
                [disabled]="!canIncrement(product) || product.available === false"
            class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center
            hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                +
              </button>
            </div>
          </div>
        </div>
      }

    </div>
  </mat-dialog-content>

  <div class="px-6 py-4 border-t border-gray-100 ">

    @if (hasSelection()) {
      <div class="mb-4 p-4 bg-green-50 rounded-lg overflow-y-auto" style="max-height: 120px;">
        <!-- Supplements list -->
        @if (getAllSelectedSupplements().length > 0) {
            <div class="mb-3 flex flex-col min-h-0">
            <p class="text-sm font-medium text-gray-700 mb-2">Suppléments choisis :</p>
            <div class="grid grid-cols-1 gap-2 text-sm">
              @for (supp of getAllSelectedSupplements(); track supp.uniqueId) {
              <div class="flex justify-between items-center bg-white rounded-lg px-3 py-2 border border-gray-100">
                <span class="text-gray-400">
              {{ supp.name }}
              @if (supp.quantity && supp.quantity > 1) {
              <span class="text-primary">×{{ supp.quantity }}</span>
              }
              </span>
              <span class="font-medium text-primary">
                +{{ (supp.price * (supp.quantity || 1)) | number:'1.2-2' }} €
    </span>
  </div>
              }
            </div>
          </div>
        }
        <!-- ✅ Total produits = base + supplements -->
        @if (!isSetPriceReduction()) {
          <div class="flex justify-between text-sm">
            <span class=" text-[#1A1A1A]">Total produits</span>
            <span class="font-semibold  text-[#1A1A1A]">
              {{ (getTotalBasePrice() + getTotalSupplements()) | number:'1.2-2' }} €
            </span>
          </div>
        }
        <!-- ✅ Remise on base price only -->
        @if (!isSetPriceReduction()) {
          <div class="flex justify-between text-sm text-green-700 mt-1">
            <span>
              Remise
              @if (data.rule.reduction?.type === 'PERCENTAGE') {
                ({{ (data.rule.reduction?.value || 0) * 100 | number:'1.0-0' }}%)
              }
            </span>
            <span class="font-bold">- {{ getDiscountAmount() | number:'1.2-2' }} €</span>
          </div>
        }
        <!-- ✅ Total = (base - discount) + supplements -->
        <div class="flex justify-between border-t border-green-200 pt-3 mt-3 font-bold text-[#1A1A1A]">
          <span>Total après remise</span>
          <span class=" text-[#1A1A1A]">{{ getTotalAfterDiscount() | number:'1.2-2' }} €</span>
        </div>
      </div>
    }
    <div class="flex gap-3">
      <button (click)="cancel()"
              [matButton]="themeConfig.appearance.button.cancel"
              class="flex-1 py-2.5">
        Annuler
      </button>
      <button (click)="confirm()"
              [matButton]="themeConfig.appearance.button.action"
              [disabled]="!hasSelection()"
            class="flex-1 py-2.5 ">
        Confirmer
      </button>
    </div>
  </div>

